import { postAxios, getAxios } from '@/lib/http';
export const companyApi = {
  // 查询机构详情 by lianmin
  getCompanyInfo () {
    return getAxios('/app/company/info');
  },
};
